export enum ScheduleFrequency {
  ONCE = 'ONCE',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
  NTH_WEEKDAY_OF_MONTH = 'NTH_WEEKDAY_OF_MONTH',
  HOLIDAY = 'HOLIDAY'
}

export const ScheduleFrequencyTranslation = {
  [ScheduleFrequency.ONCE]: 'enum.scheduleFrequency.once',
  [ScheduleFrequency.DAILY]: 'enum.scheduleFrequency.daily',
  [ScheduleFrequency.WEEKLY]: 'enum.scheduleFrequency.weekly',
  [ScheduleFrequency.MONTHLY]: 'enum.scheduleFrequency.monthly',
  [ScheduleFrequency.YEARLY]: 'enum.scheduleFrequency.yearly',
  [ScheduleFrequency.NTH_WEEKDAY_OF_MONTH]: 'enum.scheduleFrequency.nth_weekday_of_month',
  [ScheduleFrequency.HOLIDAY]: 'enum.scheduleFrequency.holiday'
};
